import { AutoWorkerService } from '@weave/schema-gen-ts/dist/schemas/messaging/auto-worker/v1/service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaAutoWorker = bindHTTP(AutoWorkerService);
